import { render, staticRenderFns } from "./nice-paginator-item.vue?vue&type=template&id=6e2483fa&scoped=true"
import script from "./nice-paginator-item.vue?vue&type=script&lang=js"
export * from "./nice-paginator-item.vue?vue&type=script&lang=js"
import style0 from "./nice-paginator-item.vue?vue&type=style&index=0&id=6e2483fa&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e2483fa",
  null
  
)

export default component.exports